// "แก้ไขเนื้อหาเว็บ" — edits every section of the redesigned public site.
// Fields are generated from the section's data shape (site-content-v2.json), so adding a
// field to the defaults makes it editable here without extra code.
import React, { useCallback, useEffect, useState } from "react";
import { useSiteContent } from "../../context/SiteContentContext";
import { DEFAULT_SITE_CONTENT, loadSiteContentFromServer } from "../../services/contentService";
import "./AdminContentEditor.css";
import DateInput from "../../components/site/DateInput";

const dc = (v) => JSON.parse(JSON.stringify(v));

const SECTIONS = [
  { key: "siteHeader", label: "Header / เมนู" },
  { key: "homeHero", label: "หน้าแรก · Hero" },
  { key: "homePrinciples", label: "แถบคุณค่า" },
  { key: "homeNews", label: "ข่าวจากกลุ่ม" },
  { key: "homeGroup", label: "01 กลุ่มบริษัท" },
  { key: "homeServices", label: "02 บริการ" },
  { key: "homeDaily", label: "03 ฉบับรายวัน" },
  { key: "homeJourney", label: "04 ขั้นตอน" },
  { key: "homeContact", label: "05 ติดต่อเรา" },
  { key: "newspaperPage", label: "หน้าหนังสือพิมพ์" },
  { key: "submitPage", label: "หน้าส่งประกาศ" },
  { key: "paymentInfo", label: "ช่องทางชำระเงิน" },
  { key: "statusPage", label: "หน้าติดตามสถานะ" },
  { key: "siteFooter", label: "Footer" },
  { key: "newspaperPaper", label: "หัว / ท้ายหนังสือพิมพ์" },
];

const LABELS = {
  brandName: "ชื่อแบรนด์", brandTagline: "คำโปรยใต้แบรนด์", tagline: "คำโปรย",
  menu: "เมนู", label: "ข้อความ", to: "ลิงก์ไปที่", ctaLabel: "ปุ่มหลัก (ข้อความ)", ctaTo: "ปุ่มหลัก (ลิงก์)",
  eyebrow: "หัวข้อเล็ก (ภาษาอังกฤษ)", title: "หัวข้อ", titleAccent: "หัวข้อ (ส่วนเน้นสี)",
  description: "คำอธิบาย", text: "รายละเอียด", note: "หมายเหตุ",
  primaryLabel: "ปุ่มหลัก", secondaryLabel: "ลิงก์รอง", signature: "คำลงท้าย (3 คำ)",
  imageUrl: "URL รูปภาพ (เว้นว่าง = รูปเริ่มต้น)", imageAlt: "คำอธิบายรูป", photoCaption: "ข้อความบนรูป",
  tagLine: "ป้าย: บรรทัดแรก", tagStrong: "ป้าย: บรรทัดเน้น", verticalCaption: "ข้อความแนวตั้ง",
  linkLabel: "ข้อความลิงก์", link: "ลิงก์", emptyLabel: "ป้ายเมื่อยังไม่มีข่าว", emptyText: "ข้อความเมื่อยังไม่มีข้อมูล (ข่าว / ช่องทางชำระเงิน)",
  items: "รายการ", date: "วันที่",
  companies: "บริษัท", logo: "โลโก้ (accounting / news)", logoAlt: "คำอธิบายโลโก้", number: "หมายเลข", name: "ชื่อ",
  purpose: "วิสัยทัศน์ / พันธกิจ", groups: "กลุ่มบริการ", anchor: "รหัส anchor",
  steps: "ขั้นตอน", links: "ลิงก์", copyrightBrand: "ชื่อในลิขสิทธิ์",
  paperTopline: "กระดาษ: บรรทัดบน", paperTitle: "กระดาษ: ชื่อหัว", paperSubtitle: "กระดาษ: คำรอง",
  paperDateLeft: "กระดาษ: แถบวันที่ซ้าย", paperDateRight: "กระดาษ: แถบวันที่ขวา", paperHeadline: "กระดาษ: พาดหัว",
  paperColumnLeft: "กระดาษ: คอลัมน์ซ้าย", paperColumnRight: "กระดาษ: คอลัมน์ขวา", paperStamp: "กระดาษ: ตราประทับ",
  paperBottom: "กระดาษ: บรรทัดล่าง",
  phoneLabel: "ป้ายโทรศัพท์", phone: "เบอร์โทร", emailLabel: "ป้ายอีเมล", email: "อีเมล",
  lineLabel: "ป้าย LINE", lineId: "LINE ID", lineUrl: "ลิงก์ LINE", officeLabel: "ป้ายสำนักงาน", address: "ที่อยู่",
  mapLabel: "ข้อความลิงก์แผนที่", mapUrl: "ลิงก์แผนที่", hours: "เวลาทำการ", hoursNote: "หมายเหตุเวลาทำการ",
  formEyebrow: "ฟอร์ม: หัวข้อเล็ก", formTitle: "ฟอร์ม: หัวข้อ", formIntro: "ฟอร์ม: คำอธิบาย",
  formNameLabel: "ฟอร์ม: ช่องชื่อ", formBusinessLabel: "ฟอร์ม: ช่องกิจการ", formServiceLabel: "ฟอร์ม: ช่องบริการ",
  formServices: "ฟอร์ม: ตัวเลือกบริการ", formProblemLabel: "ฟอร์ม: ช่องโจทย์", formProblemPlaceholder: "ฟอร์ม: ข้อความตัวอย่าง",
  formPrivacy: "ฟอร์ม: หมายเหตุความเป็นส่วนตัว", formSubmitLabel: "ฟอร์ม: ปุ่มส่ง",
  subtitle: "คำรอง", strip: "แถบข้อความ", stripLinkLabel: "แถบข้อความ: ลิงก์",
  leadEyebrow: "ส่วนนำ: หัวข้อเล็ก", leadTitle: "ส่วนนำ: หัวข้อ", leadText: "ส่วนนำ: คำอธิบาย", leadButton: "ส่วนนำ: ปุ่ม",
  todayLabel: "ฉบับวันนี้: ป้าย", todayTitle: "ฉบับวันนี้: หัวข้อ", todayEmpty: "ฉบับวันนี้: เมื่อยังไม่มีรายการ", todayOpenLabel: "ฉบับวันนี้: ลิงก์เปิดฉบับ",
  listTitle: "รายการ: หัวข้อ", listCaption: "รายการ: คำอธิบาย", searchPlaceholder: "ช่องค้นหา: ข้อความตัวอย่าง", searchButton: "ปุ่มค้นหา",
  emptyTitle: "เมื่อไม่มีรายการ: หัวข้อ", emptyLink: "เมื่อไม่มีรายการ: ลิงก์",
  archiveEyebrow: "ฉบับย้อนหลัง: หัวข้อเล็ก", archiveTitle: "ฉบับย้อนหลัง: หัวข้อ",
  helpTitle: "กล่องช่วยเหลือ: หัวข้อ", helpText: "กล่องช่วยเหลือ: ข้อความ", helpButton: "กล่องช่วยเหลือ: ปุ่ม", statusLink: "ลิงก์ติดตามสถานะ",
  editionDownload: "ฉบับรายวัน: ปุ่มดาวน์โหลด", editionLocked: "ฉบับรายวัน: ข้อความเมื่อยังดาวน์โหลดไม่ได้",
  frontEmptyLabel: "หน้า 1: ป้าย", frontEmptyTitle: "หน้า 1: หัวข้อ", frontEmptyText: "หน้า 1: ข้อความ", noNotices: "ข้อความเมื่อฉบับไม่มีประกาศ",
  methods: "วิธีลงประกาศ 3 วิธี", chooseLabel: "ข้อความปุ่มเลือก",
  guidanceEyebrow: "คำแนะนำ: หัวข้อเล็ก", guidanceTitle: "คำแนะนำ: หัวข้อ", guidanceSteps: "คำแนะนำ: ขั้นตอน",
  paymentTitle: "การชำระเงิน: หัวข้อ", paymentText: "การชำระเงิน: ข้อความ",
  successTitle: "หลังส่งสำเร็จ: หัวข้อ", successText: "หลังส่งสำเร็จ: ข้อความ", lockedText: "ข้อความก่อนอนุมัติ",
  nextEyebrow: "กล่องติดต่อแอดมิน: หัวข้อเล็ก",
  nextSubmittedTitle: "รอชำระเงิน: หัวข้อ", nextSubmittedText: "รอชำระเงิน: ข้อความ",
  nextPaidTitle: "ชำระแล้ว รออนุมัติ: หัวข้อ", nextPaidText: "ชำระแล้ว รออนุมัติ: ข้อความ",
  nextRejectedTitle: "ไม่อนุมัติ: หัวข้อ", nextRejectedText: "ไม่อนุมัติ: ข้อความ",
  nextLineSlipLabel: "ปุ่ม LINE (ส่งสลิป)", nextLineAskLabel: "ปุ่ม LINE (สอบถาม)", nextPhoneLabel: "ปุ่มโทร", nextEmailLabel: "ลิงก์อีเมล",
  priceNote: "ราคาลงประกาศ (แสดงบนหน้าส่งประกาศ)",
  // newspaperPaper — masthead "ฉบับที่ N ปีที่ Y วันที่ … ราคา … บาท" and the back cover of every edition
  firstIssueDate: "วันที่ฉบับที่ 1 (เริ่มนับฉบับที่ / ปีที่)", price: "ราคาหน้าปก (บาท)", website: "เว็บไซต์บนหัวหนังสือพิมพ์",
  qrCaption: "ข้อความใต้ QR code", registrationNo: "เลขทะเบียน (เว้นว่าง = ยังไม่แสดง)", issn: "ISSN (เว้นว่าง = ยังไม่แสดง)",
  bannerTitle: "ท้ายเล่ม: แถบใหญ่ บรรทัดที่ 1", bannerSubtitle: "ท้ายเล่ม: แถบใหญ่ บรรทัดที่ 2", bannerContact: "ท้ายเล่ม: ช่องทางติดต่อ",
  editorLine: "ท้ายเล่ม: บรรณาธิการ ผู้พิมพ์ ผู้โฆษณา", officeLine: "ท้ายเล่ม: ที่อยู่สำนักงาน",
  sendToLabel: "ท้ายเล่ม: ข้อความช่องจ่าหน้า",
  // paymentInfo — payment box after submitting (account no. / QR are easier to set on /admin/editor → ช่องทางชำระเงิน)
  pricePerNotice: "ค่าลงประกาศ (บาท / เรื่อง)", pricePerCopy: "หนังสือพิมพ์ฉบับพิมพ์ (บาท / เล่ม)",
  promptPayId: "พร้อมเพย์ (เบอร์โทร / เลขผู้เสียภาษี)", promptPayName: "ชื่อบัญชีพร้อมเพย์", qrUrl: "รูป QR (อัปโหลดที่ ประกาศจากลูกค้า → ช่องทางชำระเงิน)",
  bankName: "ธนาคาร", accountNo: "เลขบัญชี", accountName: "ชื่อบัญชี", slipTitle: "หัวข้อช่องแนบสลิป", slipNote: "คำอธิบายไฟล์สลิป",
  slipDoneText: "ข้อความหลังแนบสลิปแล้ว",
};

// Shape of a new row for lists whose default is empty (e.g. homeNews.items)
const LIST_SAMPLES = {
  items: { date: "", title: "", text: "", link: "" },
};

const labelOf = (key) => LABELS[key] || key;

// Empty copy of an item, used when adding a new row to a list
function blankLike(sample) {
  if (Array.isArray(sample)) return [];
  if (sample && typeof sample === "object") {
    return Object.fromEntries(Object.entries(sample).map(([k, v]) => [k, blankLike(v)]));
  }
  return "";
}

function TextField({ label, value, onChange }) {
  const text = String(value ?? "");
  const multiline = text.includes("\n") || text.length > 70;
  return (
    <label className="ace-field">
      <span>{label}</span>
      {multiline ? (
        <textarea rows={Math.min(8, Math.max(2, text.split("\n").length + 1))} value={text} onChange={(e) => onChange(e.target.value)} />
      ) : (
        <input value={text} onChange={(e) => onChange(e.target.value)} />
      )}
    </label>
  );
}

function ListField({ label, value, sample, onChange }) {
  const list = Array.isArray(value) ? value : [];
  const template = list[0] !== undefined ? list[0] : sample;
  const isObjectList = template && typeof template === "object";

  const setAt = (i, v) => onChange(list.map((item, j) => (j === i ? v : item)));
  const removeAt = (i) => onChange(list.filter((_, j) => j !== i));
  const move = (i, dir) => {
    const j = i + dir;
    if (j < 0 || j >= list.length) return;
    const next = [...list];
    [next[i], next[j]] = [next[j], next[i]];
    onChange(next);
  };
  const add = () => onChange([...list, template !== undefined ? blankLike(template) : ""]);

  return (
    <fieldset className="ace-list">
      <legend>{label}</legend>
      {list.map((item, i) => (
        <div className={`ace-list-item${isObjectList ? " card" : ""}`} key={i}>
          <span className="ace-list-index">{String(i + 1).padStart(2, "0")}</span>
          <div className="ace-list-body">
            {isObjectList ? (
              <ObjectFields value={item} onChange={(v) => setAt(i, v)} />
            ) : (
              <input value={String(item ?? "")} onChange={(e) => setAt(i, e.target.value)} />
            )}
          </div>
          <div className="ace-list-actions">
            <button type="button" onClick={() => move(i, -1)} aria-label="เลื่อนขึ้น">↑</button>
            <button type="button" onClick={() => move(i, 1)} aria-label="เลื่อนลง">↓</button>
            <button type="button" onClick={() => removeAt(i)} aria-label="ลบ">×</button>
          </div>
        </div>
      ))}
      <button type="button" className="text-link ace-add" onClick={add}>
        เพิ่มรายการ <span>+</span>
      </button>
    </fieldset>
  );
}

function ObjectFields({ value, sampleObject, onChange }) {
  const obj = value && typeof value === "object" ? value : {};
  const keys = Array.from(new Set([...Object.keys(sampleObject || {}), ...Object.keys(obj)]));
  return keys.map((key) => {
    const v = obj[key] !== undefined ? obj[key] : blankLike(sampleObject?.[key]);
    const set = (nv) => onChange({ ...obj, [key]: nv });
    if (Array.isArray(v) || Array.isArray(sampleObject?.[key])) {
      const sample = (Array.isArray(sampleObject?.[key]) && sampleObject[key][0]) || LIST_SAMPLES[key];
      return <ListField key={key} label={labelOf(key)} value={v} sample={sample} onChange={set} />;
    }
    if (v && typeof v === "object") {
      return (
        <fieldset className="ace-list" key={key}>
          <legend>{labelOf(key)}</legend>
          <ObjectFields value={v} sampleObject={sampleObject?.[key]} onChange={set} />
        </fieldset>
      );
    }
    if (key === "date" || /Date$/.test(key)) {
      // front-page news is matched to an edition by this date — the dd-mm-yyyy box keeps it a valid YYYY-MM-DD
      return (
        <label className="ace-field" key={key}>
          <span>{labelOf(key)}</span>
          <DateInput value={String(v ?? "")} onChange={(e) => set(e.target.value)} />
        </label>
      );
    }
    return <TextField key={key} label={labelOf(key)} value={v} onChange={set} />;
  });
}

function AdminContentEditor() {
  const { setContent } = useSiteContent();
  const [draft, setDraft] = useState(null);
  const [loadError, setLoadError] = useState("");
  const [dirty, setDirty] = useState(() => new Set());
  const [active, setActive] = useState(SECTIONS[0].key);
  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");

  // Edit only what the server really has: never seed the form from cache or defaults,
  // otherwise one save could overwrite the live site with stand-in text.
  const load = useCallback(async () => {
    setLoadError("");
    try {
      setDraft(dc(await loadSiteContentFromServer()));
      setDirty(new Set());
    } catch (e) {
      setLoadError(`โหลดเนื้อหาจากเซิร์ฟเวอร์ไม่ได้ (${e.message}) — ยังแก้ไขไม่ได้เพื่อป้องกันการบันทึกทับข้อมูลจริง`);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const updateSection = (value) => {
    setDraft((prev) => ({ ...prev, [active]: value }));
    setDirty((prev) => new Set(prev).add(active));
    setStatus("");
    setError("");
  };

  const save = async () => {
    if (dirty.size === 0) {
      setStatus("ยังไม่มีการแก้ไข");
      return;
    }
    setSaving(true);
    setError("");
    try {
      // send only the sections that were edited; the server keeps every other section as it is
      const changed = Object.fromEntries([...dirty].map((key) => [key, draft[key]]));
      await setContent(changed);
      setDirty(new Set());
      setStatus("บันทึกแล้ว · หน้าเว็บจะอัปเดตภายใน 30 วินาที");
    } catch (e) {
      const msg = String(e.message || "");
      setError(/401|เข้าสู่ระบบ/.test(msg) ? "เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่" : `บันทึกไม่สำเร็จ: ${msg}`);
    } finally {
      setSaving(false);
    }
  };

  const resetSection = () => {
    if (!window.confirm("คืนค่าเริ่มต้นของส่วนนี้? (ยังไม่บันทึกจนกว่าจะกดบันทึก)")) return;
    updateSection(dc(DEFAULT_SITE_CONTENT[active] || {}));
  };

  if (loadError) {
    return (
      <div className="ace-loading">
        <p className="adm-msg err">{loadError}</p>
        <button type="button" className="button dark" onClick={load}>ลองโหลดอีกครั้ง</button>
      </div>
    );
  }

  if (!draft) {
    return <div className="ace-loading">กำลังโหลดเนื้อหา...</div>;
  }

  const sectionLabel = SECTIONS.find((s) => s.key === active)?.label;

  return (
    <div className="ace-root">
      <p className="adm-note ace-intro">แก้ข้อความทุกส่วนของหน้าเว็บ แล้วกดบันทึก · ผู้เข้าชมจะเห็นการเปลี่ยนแปลงภายใน 30 วินาที</p>

      <div className="ace-layout">
        <nav className="ace-tabs" aria-label="เลือกส่วนที่จะแก้ไข">
          {SECTIONS.map((s, i) => (
            <button
              key={s.key}
              type="button"
              className={`ace-tab${active === s.key ? " active" : ""}`}
              onClick={() => { setActive(s.key); setStatus(""); setError(""); }}
            >
              <span>{String(i + 1).padStart(2, "0")}</span>
              <strong>{s.label}{dirty.has(s.key) ? " •" : ""}</strong>
              <span className="tab-arrow">→</span>
            </button>
          ))}
        </nav>

        <section className="ace-panel site-form">
          <div className="ace-panel-head">
            <h3>{sectionLabel}</h3>
            <button type="button" className="text-link" onClick={resetSection}>คืนค่าเริ่มต้น</button>
          </div>
          <ObjectFields
            value={draft[active]}
            sampleObject={DEFAULT_SITE_CONTENT[active]}
            onChange={updateSection}
          />
          <div className="ace-savebar">
            <div role="status">
              {status && <span className="ace-status ok">{status}</span>}
              {error && <span className="ace-status err">{error}</span>}
            </div>
            <button type="button" className="button dark" onClick={save} disabled={saving}>
              {saving ? "กำลังบันทึก..." : dirty.size ? `บันทึกเนื้อหา (${dirty.size} ส่วน)` : "บันทึกเนื้อหา"}
              <span>↗</span>
            </button>
          </div>
        </section>
      </div>
    </div>
  );
}

export default AdminContentEditor;
